import { db } from "../../../config/firebaseconfig"
import { uniqBy } from 'lodash'

export default function getActiveorExpiredLicenses(licenses, { getUserLicenseRequest, getUserLicenseSuccess, getUserLicenseFailure }) {
    getUserLicenseRequest()
    let licensesArr = []
    let licensePromise = []
    Object.entries(licenses).forEach(license => {
        if (license[1]) {
            let dataLicenses = db.collection('accountLicenses').where('id', '==', license[0]).get()
            licensePromise.push(dataLicenses)
        }
    })

    return Promise.all(licensePromise).then(result => {
        result.forEach(querySnapshot => {
            querySnapshot.forEach(doc => {
                if (doc.exists) {
                    const data = doc.data()
                    if(!data.deleted) licensesArr.push(data)
                }
            })
        })
        getUserLicenseSuccess(uniqBy(licensesArr, 'licenseSet'))
    })
        .catch(err => getUserLicenseFailure(err))


}




// WEBPACK FOOTER //
// ./src/helpers/users/licenses/getActiveorExpiredLicenses.js